const InstagramIcon = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10906_32041)">
        <path
          d="M9.99998 11.9247C11.0631 11.9247 11.925 11.0628 11.925 9.99967C11.925 8.93653 11.0631 8.07467 9.99998 8.07467C8.93683 8.07467 8.07498 8.93653 8.07498 9.99967C8.07498 11.0628 8.93683 11.9247 9.99998 11.9247Z"
          fill="url(#paint0_linear_10906_32041)"
        />
        <path
          d="M9.99998 0.833008C4.93738 0.833008 0.833313 4.93707 0.833313 9.99967C0.833313 15.0623 4.93738 19.1663 9.99998 19.1663C15.0626 19.1663 19.1666 15.0623 19.1666 9.99967C19.1666 4.93707 15.0626 0.833008 9.99998 0.833008ZM15.6634 12.3295C15.6194 13.201 15.3745 14.0604 14.7394 14.6887C14.0982 15.323 13.2347 15.5594 12.3548 15.603H7.64517C6.76517 15.5594 5.90182 15.3232 5.26056 14.6887C4.62542 14.0604 4.38056 13.201 4.33656 12.3295V7.66987C4.38056 6.79838 4.62545 5.93899 5.26056 5.31059C5.90182 4.67626 6.76528 4.43991 7.64517 4.39638H12.3548C13.2348 4.43991 14.0981 4.67615 14.7394 5.31059C15.3745 5.93899 15.6194 6.79838 15.6634 7.66987L15.6634 12.3295Z"
          fill="url(#paint1_linear_10906_32041)"
        />
        <path
          d="M12.2953 5.45807C11.1482 5.42661 8.85209 5.42661 7.70494 5.45807C7.10797 5.47446 6.43121 5.62307 6.00588 6.07737C5.5639 6.5496 5.39688 7.12013 5.37994 7.75839C5.35017 8.87863 5.37994 12.241 5.37994 12.241C5.39934 12.8791 5.5639 13.4497 6.00588 13.922C6.43121 14.3764 7.10797 14.5249 7.70494 14.5413C8.85209 14.5727 11.1482 14.5727 12.2953 14.5413C12.8923 14.5249 13.569 14.3763 13.9944 13.922C14.4364 13.4497 14.6034 12.8792 14.6203 12.241V7.75839C14.6034 7.12013 14.4364 6.5496 13.9944 6.07737C13.5689 5.62292 12.8921 5.47446 12.2953 5.45807ZM9.99998 12.9834C9.40985 12.9834 8.83297 12.8084 8.3423 12.4806C7.85162 12.1527 7.46919 11.6867 7.24335 11.1415C7.01752 10.5963 6.95843 9.99636 7.07356 9.41757C7.18869 8.83878 7.47286 8.30713 7.89015 7.88984C8.30743 7.47256 8.83909 7.18839 9.41788 7.07326C9.99667 6.95813 10.5966 7.01722 11.1418 7.24305C11.687 7.46888 12.153 7.85132 12.4809 8.34199C12.8087 8.83267 12.9837 9.40954 12.9837 9.99967C12.9837 10.791 12.6694 11.5499 12.1098 12.1095C11.5502 12.6691 10.7913 12.9834 9.99998 12.9834ZM12.9964 7.63181C12.8784 7.63178 12.763 7.59676 12.6649 7.53117C12.5668 7.46558 12.4903 7.37237 12.4452 7.26333C12.4001 7.15428 12.3883 7.0343 12.4113 6.91855C12.4343 6.80281 12.4912 6.69649 12.5746 6.61305C12.6581 6.5296 12.7644 6.47278 12.8802 6.44977C12.9959 6.42676 13.1159 6.43858 13.225 6.48375C13.334 6.52892 13.4272 6.60541 13.4928 6.70354C13.5583 6.80167 13.5933 6.91704 13.5933 7.03506C13.5933 7.11344 13.5779 7.19105 13.5479 7.26346C13.5179 7.33587 13.4739 7.40167 13.4185 7.45708C13.363 7.5125 13.2972 7.55645 13.2248 7.58643C13.1524 7.61641 13.0748 7.63183 12.9964 7.63181Z"
          fill="url(#paint2_linear_10906_32041)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10906_32041"
          x1="9.99998"
          y1="0.833008"
          x2="9.99998"
          y2="19.1663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4C4EDA" />
          <stop offset="0.536458" stopColor="#CE2E80" />
          <stop offset="1" stopColor="#FCC44B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10906_32041"
          x1="9.99998"
          y1="0.833008"
          x2="9.99998"
          y2="19.1663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4C4EDA" />
          <stop offset="0.536458" stopColor="#CE2E80" />
          <stop offset="1" stopColor="#FCC44B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10906_32041"
          x1="9.99998"
          y1="0.833008"
          x2="9.99998"
          y2="19.1663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4C4EDA" />
          <stop offset="0.536458" stopColor="#CE2E80" />
          <stop offset="1" stopColor="#FCC44B" />
        </linearGradient>
        <clipPath id="clip0_10906_32041">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InstagramIcon;
